import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MobilePaymentComponent } from './components/mobile-payment/mobile-payment.component';

const routes: Routes = [
  {
    path: '', 
    component: MobilePaymentComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MobilePaymentRoutingModule { }
